<div class="columns is-mobile table-header">
  <div class="column table-header__column">{{ 'PAYMENT.QUANTITY' | translate }}</div>
  <div class="column table-header__column">{{ 'PAYMENT.AMOUNT' | translate }}</div>
  <div class="column table-header__column">{{ 'PAYMENT.CREATION_DATE' | translate }}</div>
  <div class="column table-header__column">{{ 'PAYMENT.CLEARED_DATE' | translate }}</div>
  <div class="column table-header__column">{{ 'PAYMENT.STATUS' | translate }}</div>
  <div class="column table-header__column">{{ 'PAYMENT.INVOICE' | translate }}</div>
</div>
<div class="list-view-list">
  @for (payment of payments; track payment; let i = $index) {
    <div class="list-view-item" (click)="toggleItem(i)">
      <app-payment-list-item
        [payment]="payment"
        [openedItems]="openedItems"
        [index]="i"
        (downloadInvoice)="emitDownloadInvoice(payment)">
      </app-payment-list-item>
    </div>
  }
</div>
